import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { CommonUtils } from "./CommonUtils";
import { CustomPOIClass } from "./CustomPOI";
import mapboxgl from "mapbox-gl";

export class CustomPolygonClass {
  static polygonDefaultStyle = {
    polygonColor: "#3bb2d0",
    polygonOpacity: 0.5,
    polygonBorderColor: "#b5ef9d",
    polygonBorderWidth: 3,
  };

  static lassoDefaultStyle = {
    polygonColor: "#ffe400",
    polygonOpacity: 0.5,
    polygonBorderColor: "#FFFFFF",
    polygonBorderWidth: 3,
  };

  static GetPolygonStyles = () => {
    return [
      {
        id: "gl-draw-line",
        type: "line",
        filter: [
          "all",
          ["==", "$type", "LineString"],
          ["!=", "mode", "static"],
        ],
        layout: {
          "line-cap": "round",
          "line-join": "round",
        },
        paint: {
          "line-dasharray": [1],
          "line-color": [
            "case",
            ["has", "user_line-color"],
            ["get", "user_line-color"],
            this.polygonDefaultStyle.polygonBorderColor,
          ],
          "line-width": [
            "case",
            ["has", "user_line-width"],
            ["get", "user_line-width"],
            this.polygonDefaultStyle.polygonBorderWidth * 1.1,
          ],
          // "line-color": this.polygonDefaultStyle.polygonBorderColor,
          // "line-width": this.polygonDefaultStyle.polygonBorderWidth * 1.1,
        },
      },
      // polygon fill
      {
        id: "gl-draw-polygon-fill",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        paint: {
          "fill-color": [
            "case",
            ["has", "user_fill-color"],
            ["get", "user_fill-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
          "fill-outline-color": [
            "case",
            ["has", "user_fill-outline-color"],
            ["get", "user_fill-outline-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
          "fill-opacity": [
            "case",
            ["has", "user_fill-opacity"],
            ["get", "user_fill-opacity"],
            0,
          ],
        },
      },
      // polygon mid points
      {
        id: "gl-draw-polygon-midpoint",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
        paint: {
          "circle-radius": [
            "case",
            ["has", "user_circle-radius"],
            ["get", "user_circle-radius"],
            0,
          ],
          "circle-color": [
            "case",
            ["has", "user_circle-color"],
            ["get", "user_circle-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
        },
      },
      // polygon outline stroke
      // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
      {
        id: "gl-draw-polygon-stroke-active",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        layout: {
          "line-cap": "round",
          "line-join": "round",
        },
        paint: {
          "line-color": [
            "case",
            ["has", "user_line-color"],
            ["get", "user_line-color"],
            this.polygonDefaultStyle.polygonBorderColor,
          ],
          "line-dasharray": [1],
          "line-width": [
            "case",
            ["has", "user_line-width"],
            ["get", "user_line-width"],
            this.polygonDefaultStyle.polygonBorderWidth,
          ],
        },
      },
      // vertex point halos
      {
        id: "gl-draw-polygon-and-line-vertex-halo-active",
        type: "circle",
        filter: [
          "all",
          ["==", "meta", "vertex"],
          ["==", "$type", "Point"],
          ["!=", "mode", "static"],
        ],
        paint: {
          "circle-radius": [
            "case",
            ["has", "user_circle-radius"],
            ["get", "user_circle-radius"],
            0,
          ],
          "circle-color": [
            "case",
            ["has", "user_circle-color"],
            ["get", "user_circle-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
        },
      },
      // vertex points
      {
        id: "gl-draw-polygon-and-line-vertex-active",
        type: "circle",
        filter: [
          "all",
          //    ["==", "meta", "vertex"],
          ["==", "$type", "Point"],
          ["!=", "mode", "static"],
        ],
        paint: {
          "circle-radius": [
            "case",
            ["has", "user_circle-radius"],
            ["get", "user_circle-radius"],
            6,
          ],
          "circle-color": [
            "case",
            ["has", "user_circle-color"],
            ["get", "user_circle-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
        },
      },

      // INACTIVE (static, already drawn)
      // line stroke
      {
        id: "gl-draw-line-static",
        type: "line",
        filter: [
          "all",
          ["==", "$type", "LineString"],
          ["==", "mode", "static"],
        ],
        layout: {
          "line-cap": "round",
          "line-join": "round",
        },
        paint: {
          "line-color": [
            "case",
            ["has", "user_fill-color"],
            ["get", "user_fill-color"],
            this.polygonDefaultStyle.polygonBorderColor,
          ],
          "line-width": [
            "case",
            ["has", "user_line-width"],
            ["get", "user_line-width"],
            this.polygonDefaultStyle.polygonBorderWidth * 2,
          ],
        },
      },
      // polygon fill
      {
        id: "gl-draw-polygon-fill-static",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
        paint: {
          "fill-color": [
            "case",
            ["has", "user_fill-color"],
            ["get", "user_fill-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
          "fill-outline-color": [
            "case",
            ["has", "user_fill-outline-color"],
            ["get", "user_fill-outline-color"],
            this.polygonDefaultStyle.polygonColor,
          ],
          "fill-opacity": [
            "case",
            ["has", "user_fill-opacity"],
            ["get", "user_fill-opacity"],
            this.polygonDefaultStyle.polygonOpacity,
          ],
        },
      },
      // polygon outline
      {
        id: "gl-draw-polygon-stroke-static",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
        layout: {
          "line-cap": "round",
          "line-join": "round",
        },
        paint: {
          "line-color": [
            "case",
            ["has", "user_line-color"],
            ["get", "user_line-color"],
            this.polygonDefaultStyle.polygonBorderColor,
          ],
          "line-width": [
            "case",
            ["has", "user_line-width"],
            ["get", "user_line-width"],
            this.polygonDefaultStyle.polygonBorderWidth * 2,
          ],
        },
      },
    ];
  };

  static ChangeFillColorOnceCreated({
    mapDraw,
    polygonInstance,
    setPolygonSelected,
    setUndoHistory,
    setRedoHistory,
    setDrawnFeaturesSupport,
    currentMode,
    map,
  }) {
    // Update the feature in the Draw instance
    const feature = mapDraw.get(polygonInstance.id);
    feature.properties["fill-opacity"] =
      this.polygonDefaultStyle.polygonOpacity;
    feature.properties["fill-color"] = this.polygonDefaultStyle.polygonColor;
    feature.properties["line-color"] =
      this.polygonDefaultStyle.polygonBorderColor;
    feature.properties["circle-color"] = this.polygonDefaultStyle.polygonColor;
    feature.properties["fill-outline-color"] =
      this.polygonDefaultStyle.polygonColor;
    feature.properties["line-width"] =
      this.polygonDefaultStyle.polygonBorderWidth;
    feature.properties["circle-radius"] =
      this.polygonDefaultStyle.polygonBorderWidth;
    feature.properties["trade-area"] = false;
    feature.properties["vertexColor"] = this.polygonDefaultStyle.polygonColor;
    feature.properties["vertexRadius"] =
      this.polygonDefaultStyle.polygonBorderWidth;
    currentMode.current = "direct_select";
    mapDraw.add(feature);
    CommonUtils.UpdateVertexColorLayer({
      featureId: polygonInstance.id,
      mapDraw,
      map,
      currentMode,
      polygonDefaultStyle: this.polygonDefaultStyle,
    });
    setPolygonSelected({
      id: polygonInstance.id,
      polygonColor: this.polygonDefaultStyle.polygonColor,
      polygonBorderColor: this.polygonDefaultStyle.polygonBorderColor,
      polygonOpacity: this.polygonDefaultStyle.polygonOpacity,
      polygonBorderWidth: this.polygonDefaultStyle.polygonBorderWidth,
      polygonColorTransparent: true,
      polygonBorderColorTransparent: true,
      isResetStyle: false,
      coordinates: feature.geometry.coordinates,
      tradeArea: false,
    });
    mapDraw.setFeatureProperty(
      polygonInstance.id,
      "fill-opacity",
      this.polygonDefaultStyle.polygonOpacity
    );
    // create Polygon history start
    //   const createdPolygon = {
    //     action: "created",
    //     type: "polygon",
    //     id: feature.id,
    //     previousValue: null,
    //     currentValue: feature,
    //   };
    //   setUndoHistory((previousValue) => {
    //     let newUndoHistory = [...previousValue];
    //     if (newUndoHistory && newUndoHistory.length >= 5) {
    //       newUndoHistory.shift();
    //     }
    //     newUndoHistory.push(createdPolygon);
    //     return newUndoHistory;
    //   });
    //   setRedoHistory([]);
    setDrawnFeaturesSupport((previousValue) => {
      previousValue[feature.id] = feature;
      return previousValue;
    });
  }

  static onChangePolygonStyle = ({
    polygonStyle,
    mapDraw,
    map,
    polygonSelected,
    setPolygonSelected,
    setUndoHistory,
    setRedoHistory,
    setDrawnFeaturesSupport,
    currentMode,
    polygonDefaultStyle,
  }) => {
    // Update the feature in the Draw instance
    if (polygonSelected) {
      const preFeature = mapDraw.get(polygonSelected.id);
      let changeLocalValue = false;
      const feature = mapDraw.get(polygonSelected.id);
      currentMode.current = "direct_select";
      if (!polygonStyle.polygonColorTransparent) {
        if (feature.properties["fill-opacity"] !== 0) {
          changeLocalValue = true;
          feature.properties["previous-fill-opacity"] =
            feature.properties["fill-opacity"];
          feature.properties["fill-opacity"] = 0;
          polygonStyle.polygonOpacity = 0;
        }
      } else {
        if (feature.properties["fill-opacity"] === 0) {
          feature.properties["fill-opacity"] =
            feature.properties["previous-fill-opacity"];
          changeLocalValue = true;
          polygonStyle.polygonOpacity =
            feature.properties["previous-fill-opacity"];
        } else {
          feature.properties["fill-opacity"] = polygonStyle.polygonOpacity;
        }
      }

      if (
        polygonStyle.polygonBorderColorTransparent &&
        polygonStyle.polygonBorderWidth > 0 &&
        (!feature.properties["previous-line-width"] ||
          feature.properties["previous-line-width"] === 0)
      ) {
        feature.properties["line-width"] = polygonStyle.polygonBorderWidth;
        feature.properties["previous-line-width"] = 0;
        feature.properties["vertexRadius"] = polygonStyle.polygonBorderWidth;
      } else if (!polygonStyle.polygonBorderColorTransparent) {
        if (feature.properties["line-width"] !== 0) {
          feature.properties["previous-line-width"] =
            feature.properties["line-width"];
          feature.properties["line-width"] = 0;
          feature.properties["vertexRadius"] = 0;
          polygonStyle.polygonBorderWidth = 0;
          changeLocalValue = true;
        }
      } else {
        if (feature.properties["line-width"] === 0) {
          feature.properties["line-width"] =
            feature.properties["previous-line-width"];
          polygonStyle.polygonBorderWidth =
            feature.properties["previous-line-width"];
          feature.properties["vertexRadius"] =
            feature.properties["previous-line-width"];
          feature.properties["previous-line-width"] = 0;
          changeLocalValue = true;
        }
      }

      feature.properties["fill-color"] = polygonStyle.polygonColor;
      feature.properties["line-color"] = polygonStyle.polygonBorderColor;
      feature.properties["fill-outline-color"] = polygonStyle.polygonColor;
      feature.properties["circle-radius"] = polygonStyle.polygonBorderWidth;
      feature.properties["circle-color"] = polygonStyle.polygonColor;
      feature.properties.vertexColor = polygonStyle.polygonColor;

      setPolygonSelected({
        id: polygonSelected.id,
        polygonColor: polygonStyle.polygonColor,
        polygonBorderColor: polygonStyle.polygonBorderColor,
        polygonOpacity: polygonStyle.polygonOpacity,
        polygonBorderWidth: polygonStyle.polygonBorderWidth,
        polygonColorTransparent: polygonStyle.polygonColorTransparent,
        polygonBorderColorTransparent:
          polygonStyle.polygonBorderColorTransparent,
        isResetStyle: changeLocalValue,
        coordinates: feature.geometry.coordinates,
        tradeArea: feature.properties["trade-area"],
      });
      // const updatedPolygon = {
      //   action: "updated",
      //   type: "polygon",
      //   id: feature.id,
      //   previousValue: preFeature,
      //   currentValue: feature,
      // };
      // setUndoHistory((previousValue) => {
      //   let newUndoHistory = [...previousValue];
      //   if (newUndoHistory && newUndoHistory.length >= 5) {
      //     newUndoHistory.shift();
      //   }
      //   newUndoHistory.push(updatedPolygon);
      //   return newUndoHistory;
      // });
      // setRedoHistory([]);
      setDrawnFeaturesSupport((previousValue) => {
        previousValue[feature.id] = feature;
        return previousValue;
      });
      setTimeout(() => {
        mapDraw.add(feature);
        mapDraw.setFeatureProperty(
          polygonSelected.id,
          "fill-color",
          polygonStyle.polygonColor
        );
        CommonUtils.UpdateVertexColorLayer({
          featureId: polygonSelected.id,
          mapDraw,
          map,
          currentMode,
          polygonDefaultStyle: this.polygonDefaultStyle,
        });
      }, 100);
    }
  };

  static CustomModes = ({ currentMode, mapRef, lastClickButton, drawRef }) => {
    const customDirectSelectMode = {
      ...MapboxDraw.modes.direct_select,
      onStop() {
        currentMode.current = "simple_select";
      },
      dragFeature: () => {
        mapRef.dragPan.enable();
      },
      onMouseDown: function (state, e) {
        const originalOnMouseDown =
          MapboxDraw.modes.direct_select.onMouseDown?.bind(this);

        // Call the original onMouseDown logic from direct_select
        originalOnMouseDown?.(state, e);

        if (
          e?.featureTarget?.properties?.meta &&
          ["vertex", "midpoint"].includes(e.featureTarget.properties.meta)
        ) {
          mapRef.dragPan.disable();
        } else {
          this.map.dragPan.enable();
        }
        if (e.featureTarget.properties?.["meta:type"] === "Polygon") {
          lastClickButton.current = e.originalEvent.button;
        }
      },
      onMouseMove: function (state, e) {
        if (typeof e.featureTarget === "undefined") {
          drawRef.current.changeMode("simple_select");
        }
      },
    };

    const customSimpleSelectMode = {
      ...MapboxDraw.modes.simple_select,
      dragMove: () => {},
      onMouseMove: function (state, e) {
        if (
          e.featureTarget
          // && !disableUserActions()
        ) {
          const featureId =
            e.featureTarget.properties.meta === "vertex"
              ? e.featureTarget.properties.parent
              : e.featureTarget.properties.id;

          if (featureId) {
            currentMode.current = "direct_select";
            CommonUtils.UpdateVertexColorLayer({
              featureId,
              mapDraw: drawRef.current,
              map: mapRef,
              currentMode,
              polygonDefaultStyle: CustomPolygonClass.polygonDefaultStyle,
            });
            const featureAlive = drawRef.current.get(featureId);
            if (featureAlive) {
              drawRef.current.changeMode("direct_select", {
                featureId,
              });
            }
          }
        }
      },
    };

    return {
      ...MapboxDraw.modes,
      simple_select: customSimpleSelectMode,
      direct_select: customDirectSelectMode,
    };
  };

  static CreatePolygon = ({
    drawRef,
    currentModeRef,
    lastClickButtonRef,
    mapRef,
    resetAllOnceChanged,
    setMapToolBarOptionFlags,
    setPolygonSelected,
    setActiveId,
    isClusterCallOut,
    createNewPolygon,
    logoDefaultStyle,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMarkers,
    getCurrentPoiSetting,
    markerRef,
    disableUserActions,
  }) => {
    drawRef.current = new MapboxDraw({
      displayControlsDefault: false,
      touchEnabled: true,
      userProperties: true,
      modes: this.CustomModes({
        currentMode: currentModeRef,
        drawRef,
        lastClickButton: lastClickButtonRef,
        mapRef,
      }),
      defaultMode: "draw_polygon",
      styles: this.GetPolygonStyles(),
    });
    mapRef.addControl(drawRef.current);

    mapRef.on("draw.selectionchange", (data) => {
      const feature = data.features;
      if (
        feature?.[0]?.geometry?.type === "Polygon" &&
        lastClickButtonRef.current === 2
        // && !showPointer.current
      ) {
        // isPolygonSelected.current = true;
        resetAllOnceChanged();
        currentModeRef.current = "direct_select";
        setMapToolBarOptionFlags((d) => ({ ...d, polygon: true }));
        setPolygonSelected({
          id: feature[0].id,
          polygonColor: feature[0].properties["fill-color"],
          polygonBorderColor: feature[0].properties["line-color"],
          polygonOpacity: feature[0].properties["fill-opacity"],
          polygonBorderWidth: feature[0].properties["line-width"],
          polygonColorTransparent:
            feature[0].properties["fill-opacity"] === 0 ? false : true,
          polygonBorderColorTransparent:
            feature[0].properties["line-width"] === 0 ? false : true,
          isResetStyle: true,
          coordinates: feature[0].geometry.coordinates,
          tradeArea: feature[0].properties["trade-area"],
        });
      }
    });
    mapRef.on("draw.update", (e) => {
      currentModeRef.current = "direct_select";
      if (e.features[0].geometry.type === "Polygon") {
        // updatePolygonHistory(
        //   e,
        //   setDrawnFeaturesSupport,
        //   setUndoHistory,
        //   setRedoHistory
        // );
      } else if (e.features[0].geometry.type === "LineString") {
        // if (e.features[0].id.startsWith("textArea")) {
        //   updateTextboxHistory(
        //     e,
        //     setDrawnFeaturesSupport,
        //     setUndoHistory,
        //     setRedoHistory
        //   );
        // } else if (
        //   e.features[0].id.startsWith("imageArea^") ||
        //   e.features[0].id.startsWith("poiImage^")
        // ) {
        //   updateLogoHistory(
        //     e,
        //     setDrawnFeaturesSupport,
        //     setUndoHistory,
        //     setRedoHistory,
        //     setMarkers
        //   );
        // }
      }
      // updateAutoSave();
    });
    mapRef.on("draw.modechange", (e) => {
      const layers = mapRef.getStyle().layers;
      const drawLayers = layers.filter((layer) =>
        layer.id.startsWith("gl-draw")
      );
      const layerIds = drawLayers.map((layer) => layer.id);
      const features = mapRef.queryRenderedFeatures({
        layers: layerIds,
      });
      if (features?.[0]?.geometry?.type === "Point") {
        const coordinates = features[0].geometry.coordinates;
        if (coordinates.length <= 2) {
          setActiveId("none");
        }
      }
    });
    mapRef.on("draw.create", (e) => {
      if (e?.features?.[0]?.geometry?.type === "Polygon") {
        mapRef.getCanvas().style.cursor = "default";
        if (isClusterCallOut.current) {
          CustomPOIClass.ClusterImageInsideBound({
            coordinates: e.features[0].geometry.coordinates,
            map: mapRef,
            mapDraw: drawRef,
            mapboxgl,
            logoDefaultStyle,
            lastClickButton: lastClickButtonRef,
            defaultLogoValue,
            poiSetting,
            setSelectedLogo,
            setMapToolBarOptionFlags,
            updateAutoSave: () => {},
            setResetMap: () => {},
            createNewPolygon,
            resetAllOnceChanged,
            currentMode: currentModeRef,
            polygonDefaultStyle: this.lassoDefaultStyle,
            getCurrentPoiSetting,
            setDrawnFeaturesSupport: () => {},
            setUndoHistory: () => {},
            setRedoHistory: () => {},
            markerRef,
            disableUserActions,
          });
          setMarkers(markerRef.current);
          isClusterCallOut.current = false;
          drawRef.current.delete(e.features[0].id);
        } else {
          currentModeRef.current = "direct_select";
          this.ChangeFillColorOnceCreated({
            mapDraw: drawRef.current,
            polygonInstance: e.features[0],
            setPolygonSelected,
            setDrawnFeaturesSupport: () => {},
            currentMode: currentModeRef,
            map: mapRef,
          });
        }
        // updateAutoSave();
      }
    });

    mapRef.on("draw.end", (e) => {
      mapRef.removeControl(drawRef.current);
    });
  };
}
